import attempt from "lodash/attempt";
import isError from "lodash/isError";
import isPlainObject from "lodash/isPlainObject";
import Long from "long";
import { match, P } from "ts-pattern";
export const DEFAULT_BG_LONG_VALUE = {
    high: 0,
    low: 0,
    unsigned: true,
};
export const longToBgLong = (value) => {
    return {
        low: value.low,
        high: value.high,
        unsigned: value.unsigned,
    };
};
export const bgLongToLong = (value) => {
    return new Long(value?.low || 0, value?.high ?? 0, value?.unsigned);
};
export const bgLongToString = (value) => {
    return bgLongToLong(value).toString();
};
export const bgLongToBigInt = (value) => {
    return bgLongToLong(value).toBigInt();
};
export const longToBigInt = (value) => {
    return value.toBigInt();
};
export const bigIntToBgLong = (value) => {
    return longToBgLong(bigIntToLong(value));
};
export const bigIntToLong = (value) => {
    return Long.fromBigInt(value, true);
};
export const numberToLong = (value) => {
    return bigIntToLong(BigInt(value));
};
export const longToNumber = (value) => {
    return value.toNumber();
};
export const bgLongToNumber = (value) => {
    return bgLongToLong(value).toNumber() || 0;
};
export const convertSize = (size, fromUnit, toUnit) => {
    const unitMap = {
        bytes: 0,
        kilobytes: 1,
        megabytes: 2,
        gigabytes: 3,
        terabytes: 4,
    };
    const fromIndex = unitMap[fromUnit];
    const toIndex = unitMap[toUnit];
    const powerDifference = fromIndex - toIndex;
    if (typeof size === "bigint") {
        const factor = BigInt(1024) ** BigInt(powerDifference);
        return Number(size * factor);
    }
    return size * 1024 ** powerDifference;
};
export const matchGeographyColumn = (input) => {
    if (!input.startsWith("{") || !input.endsWith("}")) {
        return input;
    }
    const result = attempt(() => JSON.parse(input));
    if (isError(result) || !isPlainObject(result)) {
        return input;
    }
    return match(result)
        .with({ latColumnName: P.string, lonColumnName: P.string }, ({ latColumnName, lonColumnName }) => ({
        latColumnName,
        lonColumnName,
    }))
        .otherwise(() => input);
};
export const matchGeographyColumnValue = (geographyColumn) => {
    const geo = matchGeographyColumn(geographyColumn);
    return match(geo)
        .with(P.string, (geoColumnName) => ({
        latColumnName: undefined,
        lonColumnName: undefined,
        geoColumnName,
    }))
        .otherwise((geo) => ({
        latColumnName: geo.latColumnName,
        lonColumnName: geo.lonColumnName,
        geoColumnName: undefined,
    }));
};
export const escapeDuckDBIdentifier = (columnName) => {
    return `"${columnName.replace(/"/g, '""')}"`;
};
//# sourceMappingURL=converters.js.map